import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskInput from "TaskDialogCommon/TaskInput";
import errordialog from "Common/errordialog";

const taskname = "wheel";

export default function(props) {
  const { AccountDetailData, accountdetailrow } = props;
  const [taskConfig, setTaskConfig] = React.useState({
    accountdetail: accountdetailrow,
    maxKeys: "",
    GPsToPlay: "",
    saveWheelTokens: "0",
    useWheelTokens: "99999",
    stopWhenYouGetThisItems: {},
    sleepTime: "5",
  });

  if (AccountDetailData.wheelgame === undefined) {
    errordialog.showError(
      "There is no active wheel currently. Please try laters."
    );
    return null;
  }

  const setValue = (event, key) => {
    const value = event.target.value;
    setTaskConfig({ ...taskConfig, [key]: value });
  };

  return (
    <TaskDialog heading={"Wheel Spin"}>
      <TaskInput
        label={"Max Keys(Optional)"}
        value={taskConfig.maxKeys}
        onChange={(event) => setValue(event, "maxKeys")}
        Warning={`*If entered, wheel will stop when these number of keys are won.`}
      />
      <TaskInput
        label={"GPs To Play(Optional)"}
        value={taskConfig.GPsToPlay}
        onChange={(event) => setValue(event, "GPsToPlay")}
        warning={`*If entered, wheel will stop when these number of Grand Prizes are
          won.`}
      />

      <TaskInput
        label={"Save Wheel Tokens(Optional)"}
        value={taskConfig.saveWheelTokens}
        onChange={(event) => setValue(event, "saveWheelTokens")}
        warning={`*If entered, wheel will save these many tokens and use the rest.`}
      />

      <TaskInput
        label={"Use Wheel Tokens (Optional)"}
        value={taskConfig.useWheelTokens}
        onChange={(event) => setValue(event, "useWheelTokens")}
        warning={`*If entered, wheel will use these many tokens and save the rest.`}
      />
      <TaskInput
        label={"Interval between spins (in seconds)"}
        value={taskConfig.sleepTime}
        onChange={(event) => setValue(event, "sleepTime")}
        warning={`*For safety purposes, the value is capped to 3 seconds.`}
      />

      <RunButton
        taskname={taskname}
        taskConfig={taskConfig}
        label={"Spin Wheel"}
      />
    </TaskDialog>
  );
}
